var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('p',{staticClass:"flex-shrink-0"},[_vm._v("สิ้นสุดเวลา")]),_c('p',{staticClass:"flex-grow-1"},[_vm._v(_vm._s(_vm._f("toTh")(_vm._f("moment")(_vm.publishDate,"DD MMM YYYY HH:mm"))))])])}
var staticRenderFns = []

export { render, staticRenderFns }